<!--/ REMOVE BEFORE FLIGHT: Viewport Widget -->

<ng-container *ngIf="auth.user$ | async as user">
  <section class="viewport-widget top container-fluid" *ngIf="isGodOrDev(user)">
    <div class="row">
      <div class="col-12 text-center">
        <div class="viewport-size">Viewport:
        </div>
      </div>
    </div>
  </section>
</ng-container>

<!--/ REMOVE BEFORE FLIGHT: Viewport Widget -->


<div class="header" role="banner" *ngIf="header.visible$ | async">




  <div class="container-fluid">
    <div class="row">
      <div class="col-md-4 col-6 left">
        <a href="https://cannonballcreative.agency" target="_blank" rel="noopener">
          <img class="main logo" src="assets/images/logo-cannonball@2x.png" width="538" height="112" />
        </a>
        <span class="staging-badge" *ngIf="isStaging">STAGING</span>
      </div>
      <div class="col-md-8 col-6 right">
        <nav class="navbar navbar-expand-lg navbar-light justify-content-end">
          <button class="navbar-toggler ms-auto" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
          </button>

          <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav ms-auto mb-2 mb-lg-0">



              <!-- <li class="nav-item">
                <a class="nav-link" routerLink="/dashboard" routerLinkActive="active">Dashboard</a>
              </li> -->
              <li class="nav-item">
                <a class="nav-link" routerLink="/projects" routerLinkActive="active">Projects</a>
              </li>

              <!-- <li class="nav-item">
                <a class="nav-link" routerLink="/progress" routerLinkActive="active">Progress</a>
              </li> -->

              <li class="nav-item" *ngIf="auth.userRole$ | async as role; else loadingBudget"><a class="nav-link" routerLink="/budget" routerLinkActive="active" *ngIf="role === 'god' || role === 'dev' || role === 'admin' || role === 'finance' || role === 'el' || role === 'pm'">Budget</a></li>
              <ng-template #loadingBudget></ng-template>

              <ng-container *ngIf="auth.userRole$ | async as role">

                <!-- <li class="nav-item dev" *ngIf="role === 'god' || role === 'dev' || role === 'admin'">
                  <a class="nav-link dev" routerLink="/burn" routerLinkActive="active">
                    Burn
                  </a>
                </li> -->
                <li class="nav-item" *ngIf="role === 'god' || role === 'dev'">
                  <a class="nav-link" routerLink="/status" routerLinkActive="active">Status</a>
                </li>
              </ng-container>

              <ng-container *ngIf="(auth.userRole$ | async) !== 'ic'">

                <!-- Tools dropdown nav -->
                <li class="nav-item dev dropdown" #toolsDropdownRef [class.show]="isToolsOpen">
                  <a class="nav-link dev dropdown-toggle" href="#" role="button" (click)="toggleTools($event)" [attr.aria-expanded]="isToolsOpen">
                    Tools
                  </a>
                  <ul class="dropdown-menu" [class.show]="isToolsOpen">
                    <ng-container *ngIf="auth.userRole$ | async as role; else loadingExpenses">
                      <li *ngIf="role === 'dev' || role === 'god'">
                        <a class="dropdown-item" href="#" (click)="navigateAndCloseDropdown('/tools/dev', $event)">Dev Tools</a>
                      </li>
                      <li *ngIf="role === 'dev' || role === 'god'">
                        <a class="dropdown-item" href="#" (click)="navigateAndCloseDropdown('/tools/harvest', $event)">Harvest Tools</a>
                      </li>
                      <li *ngIf="role === 'finance' || role === 'admin' || role === 'god'">
                        <a class="dropdown-item" href="#" (click)="navigateAndCloseDropdown('/tools/expenses', $event)">Expenses</a>
                      </li>
                      <li><a class="dropdown-item" href="#" (click)="navigateAndCloseDropdown('/tools/workload', $event)">Workload Diagnostics</a></li>
                    </ng-container>

                    <ng-template #loadingExpenses></ng-template>

                    <!-- Add more tool links here -->
                  </ul>
                </li>
              </ng-container>

              <!-- <li class="nav-item">
                <a class="nav-link" routerLink="/status" routerLinkActive="active">
                  Status
                </a>
              </li> -->
            </ul>

            <ng-container *ngIf="auth.user$ | async as user; else loginButton">
              <div class="user-info d-flex align-items-center">
                <div class="user-info-row clickable" (click)="navigateToSettings()" title="User Settings">
                  <span class="name me-2">{{ user.displayName || 'User' }}</span>
                  <img [src]="getAvatarUrl(user)" [alt]="user.displayName || 'User'" class="avatar rounded-circle me-2" width="32" height="32" referrerpolicy="no-referrer" crossorigin="anonymous" (error)="markPhotoUrlAsFailed(user.photoURL)">
                  <i class="bi bi-gear-fill settings-icon"></i>
                </div>
                <button class="btn btn-outline-secondary btn-sm" (click)="signOut()">Sign Out</button>
              </div>
            </ng-container>
            <ng-template #loginButton>
              <button class="btn btn-primary" (click)="auth.signInWithGoogle()">Sign In</button>
            </ng-template>
          </div>
        </nav>
      </div>
    </div>
  </div>
</div>